export default function CommencementScreenshot(){
    return (
        <>
            <img src='commencement-screenshot.webp' style={{maxWidth:'100%'}} />
            

        </>
    )
}